import { Box } from "@mui/material";
import { getStatusColor } from '../../../utils/utils';

interface BeaconActiveTableLabelProps {
    active: boolean;
}

export const BeaconActiveTableLabel: React.FC<BeaconActiveTableLabelProps> = ({active}) => {
    
    return <Box
    sx={{
      color: getStatusColor(active),
      backgroundColor: getStatusColor(active) + '44',
      borderRadius: '5px',
      fontSize: "14px",
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50%',
      width: '50%'
    }}
  >
    {active ? "Active" : "Inactive"}
  </Box>;
};